import { styled } from 'solid-styled-components';
import { SuccessIcon } from 'src/app/components';

export const SuccessIconStyled = styled(SuccessIcon)`
    margin-top: 2px;
`;
